import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function ({ store }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })
  Router.fdbStore = store
  // check authorization before entering a route
  Router.beforeEach((to, from, next) => {
    // if no session required
    if (!to.meta || !to.meta.session) {
      // => public page
      next()
    } else {
      // else: session is required
      // if have no session
      if (!Router.fdbStore.getters['session/exists']) {
        // => forward to SSO page
        next({
          name: 'SSO'
        })
      } else {
        // else: session exists
        // if no role required
        if (!to.meta.roles) {
          // => show protected page
          next()
        } else {
          // else: see if have correct role to display page
          const sessionData = Router.fdbStore.getters['session/get']
          const role = sessionData.user.role
          if (to.meta.roles.indexOf(role) != -1) {
            // have the correct role
            // => show protected page
            next()
          } else {
            // don't have the correct role
            // => forward to main page, saying "no permission"
            next('/?message=No%20permission%20for%20page%20' + to.name)
          }
        }
      }
    }
  })

  return Router
})
